module.exports = __webpack_public_path__ + "img/reviews_stats3.69fe969e.png";